import request from '@/utils/request'

export function GetBackUpDevices(guid: string): Promise<any> {
  return request.get(`/api/agri/common/repair_warehouses/${guid}/backups`, { params: {} })
}

